import { Component, OnInit } from '@angular/core';
import { FeedService } from '../../services/feed.service';
import { catchError, takeUntil, switchMap } from 'rxjs/operators';
import { EMPTY, Subject } from 'rxjs';
import * as AOS from 'aos';
import { AuthenticationService } from 'src/app/auth/fire-auth/authentication.service';
import { UserfirestoreService } from 'src/app/auth/fire-store/userfirestore.service';
import { User } from 'src/app/models/user';
import { Comment, Message, Like, Post } from '../../models/feed-model';

const MIN_LENGTH = 4;
const MAX_TITLE_LENGTH = 50;
const MAX_CONTENT_LENGTH = 8000;
@Component({
  selector: 'makaw-feed',
  templateUrl: './feed.component.html',
  styleUrls: ['./feed.component.scss'],
})
export class FeedComponent implements OnInit {
  private destroyed$ = new Subject();
  private currentUser: User;

  public dataReady = false;
  panelOpenState = false;
  hover = false;
  public content = '';
  public title = '';

  posts$ = this.feedService.posts$.pipe(
    catchError((err) => {
      console.log('Error ', err);
      this.errorMessageSubject.next(err);
      return EMPTY;
    })
  );

  private errorMessageSubject = new Subject<string>();
  errorMessage$ = this.errorMessageSubject.asObservable();

  constructor(
    private readonly feedService: FeedService,
    private readonly authenticationService: AuthenticationService,
    private readonly userService: UserfirestoreService
  ) {
    this.authenticationService
      .getStatus()
      .pipe(
        takeUntil(this.destroyed$),
        switchMap((status) =>
          this.userService.getUserById(status.uid).valueChanges()
        )
      )
      .subscribe((user: User) => {
        this.currentUser = user;
        this.dataReady = true;
      });
  }

  ngOnInit() {
    AOS.init({
      duration: 800,
      easing: 'ease-in-out',
    });
  }

  deletePost(post: Post) {
    this.feedService.deletePost(post.id);
  }

  postIsInvalid(): boolean {
    return (
      this.title.length < MIN_LENGTH ||
      this.title.length > MAX_TITLE_LENGTH ||
      this.content.length < MIN_LENGTH ||
      this.content.length > MAX_CONTENT_LENGTH
    );
  }

  sendPost() {
    const postToSend: any = {
      author: this.currentUser.firstName,
      owner: this.currentUser.uid,
      date: new Date().getTime(),
      title: this.title,
      content: this.content,
      // Backend generates an id for us.
    };
    this.title = '';
    this.content = '';
    this.feedService.createPost(postToSend);
  }

  sendComment(message: Message) {
    const comment: Comment = {
      content: message.content,
      owner: message.owner,
      author: message.author,
      date: message.date,
    };
    this.feedService.commentPost(message.postId, comment);
  }

  sendLikeEvent(likeInput: any) {
    const like: Like = {
      uid: likeInput.uid,
    };
    this.feedService.likePost(likeInput.post, like);
  }

  sendUnlikeEvent(likeInput: any) {
    const like: Like = {
      uid: likeInput.uid,
    };
    this.feedService.unlikePost(likeInput.post, like);
  }

  restartDelay() {
    this.hover = true;
  }
}
